export default __webpack_public_path__ + "images/SpeakersPhotos/Dori.jpg?004c3c5a";